import React, { useReducer, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import './hooks-styles.css';

// Defining the initial state and the reducer
const initialState = { count: 0, value: parseInt('') };
const reducerCounter = (state, action) => {
  switch (action.type) {
    case 'increment':
      return { count: state.count + 1 };
    case 'decrement':
      return { count: state.count !== 0 ? state.count - 1 : (state.count = 0) };
    case 'setValue':
      return { count: action.payload };
    case 'reset':
      return initialState;

    default:
      throw new Error('Error occured in counter');
  }
};

export default function ReactCounter() {
  //randomize background color
  const [hex, setHex] = useState('#5f5f5');
  const randomizeHex = () => {
    const randomColor = '#' + Math.floor(Math.random() * 16777215).toString(16);
    setHex(randomColor);
  };

  // Initialising useReducer hook
  const [state, dispatch] = useReducer(reducerCounter, initialState);
  const changeCounterValue = (value) => {
    dispatch({ type: 'setValue', payload: parseInt(value) });
  };

  return (
    <section
      className="backgroundColor"
      style={{
        backgroundColor: hex,
        minHeight: '33.34vh'
      }}
    >
      <Helmet>
        <title>Counter App with Custom Hook</title>
        <meta
          name="description"
          content="Counter app created with a useReducer, has increase, reduce, reset, and set value functions"
        />
        <link rel="canonical" href="/useReducerComponent" />
      </Helmet>
      <nav className="navigation">
        <ul className="nav-ul">
          <li>
            <Link className="nav-link" to="/">
              Home
            </Link>
          </li>
          <li>
            {' '}
            <Link className="nav-link" to="/useReducerComponent">
              Use Reducer
            </Link>
          </li>
          <li>
            <Link className="nav-link" to="/custom-hooks">
              Custom Hooks
            </Link>
          </li>
          <li>
            {' '}
            <Link className="nav-link" to="/TestError">
              Test Error
            </Link>
          </li>
        </ul>
      </nav>
      <div className="app">
        <div>
          <center className="header">
            <h1>UseReducer Counter</h1>
          </center>
          <div className="count">
            <h2>Count: </h2>
            <h1>{state.count}</h1>
          </div>
          <center>
            <input
              placeholder="Set Value"
              className="setValue"
              type="number"
              onChange={(e) => {
                changeCounterValue(e.target.value);
              }}
            />
          </center>
          <div className="buttons">
            <center>
              <button
                type="button"
                onClick={() => {
                  dispatch({ type: 'decrement' });
                  randomizeHex();
                }}
              >
                -
              </button>
              <button
                type="button"
                onClick={() => {
                  dispatch({ type: 'increment' });
                  randomizeHex();
                }}
              >
                +
              </button>
              <button
                type="button"
                className="reset-button"
                style={{ fontWeight: 900, fontSize: 20 }}
                onClick={() => {
                  dispatch({ type: 'reset' });
                  randomizeHex();
                }}
              >
                reset
              </button>
            </center>
          </div>
        </div>
      </div>
    </section>
  );
}
